<template>
  <div>
    <v-container fluid>
      <v-layout wrap align-center>
        <v-flex xs6><h3 class="headline my-0">SLA Timeout</h3></v-flex>
        <v-flex xs6 class="primary--text text-xs-right">
          <v-btn
            v-if="!slaSetting.isEdit"
            icon
            outline
            color="primary"
            :loading="slaSetting.loading"
            @click="slaSetting.isEdit = true"
          >
            <v-icon small>edit</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <template v-if="slaSetting.input">
        <div v-if="!slaSetting.isEdit">{{ slaSetting.input.ticket_agent_sla_time }} Sec</div>
        <template v-else>
          <SlaManagement
            :setting="slaSetting.input"
            @updateSetting="slaSetting.input = $event"
            @onClose="slaSetting.isEdit = false"
          />
        </template>
      </template>

      <v-divider class="my-4" />

      <v-layout wrap align-center>
        <v-flex xs6><h3 class="headline my-0">Close by bot time</h3></v-flex>
        <v-flex xs6 class="primary--text text-xs-right">
          <v-btn
            v-if="!closeByBotTimeSetting.isEdit"
            icon
            outline
            color="primary"
            :loading="closeByBotTimeSetting.loading"
            @click="closeByBotTimeSetting.isEdit = true"
          >
            <v-icon small>edit</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <template v-if="closeByBotTimeSetting.input">
        <div v-if="!closeByBotTimeSetting.isEdit">
          {{ closeByBotTimeSetting.input.close_by_bot_duration_time }} Sec
        </div>
        <template v-else>
          <CloseByBotManagement
            :setting="closeByBotTimeSetting.input"
            @updateSetting="closeByBotTimeSetting.input = $event"
            @onClose="closeByBotTimeSetting.isEdit = false"
          />
        </template>
      </template>
    </v-container>
  </div>
</template>

<script>
import SlaManagement from './SlaManagement.vue'
import CloseByBotManagement from './CloseByBotManagement.vue'
import ticket3PageApi from '@/api/ticket3/page.js'
import { mapGetters } from 'vuex'
import { handleApiError } from '@/api/util'
export default {
  name: 'SettingView',
  components: {
    SlaManagement,
    CloseByBotManagement
  },
  data() {
    return {
      slaSetting: {
        isEdit: false,
        input: undefined,
        loading: false
      },
      closeByBotTimeSetting: {
        isEdit: false,
        input: undefined,
        loading: false
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    this.slaSetting.loading = true
    this.closeByBotTimeSetting.loading = true
    await this.handleGetSlaTime()
    await this.handleGetCloseByBotTime()
    this.slaSetting.loading = false
    this.closeByBotTimeSetting.loading = false
  },
  methods: {
    async handleGetSlaTime() {
      try {
        const response = await ticket3PageApi.getSlaTime({
          params: {
            page_id: this.selectedBot.pageid
          }
        })
        let input = {
          ticket_agent_sla_time: 30
        }
        if (response.status == 200) {
          input = response.data
        }
        this.slaSetting.input = input
      } catch (error) {
        handleApiError(error)
      }
    },
    async handleGetCloseByBotTime() {
      try {
        const response = await ticket3PageApi.getCloseByBotTime({
          params: {
            page_id: this.selectedBot.pageid
          }
        })
        let input = {
          close_by_bot_duration_time: 30
        }
        if (response.status == 200) {
          input = response.data
        }
        this.closeByBotTimeSetting.input = input
      } catch (error) {
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/index.vue